import { render, staticRenderFns } from "./HelpDesksIssuesQueues.vue?vue&type=template&id=6c84452a"
import script from "./HelpDesksIssuesQueues.vue?vue&type=script&lang=js"
export * from "./HelpDesksIssuesQueues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports